import React from "react";

const severityBand = (value) => {
  const n = parseInt(value, 10);
  if (n <= 3) return { label: "Low severity", color: "#3a7d4f" };
  if (n <= 6) return { label: "Medium severity", color: "#c9a26a" };
  if (n <= 8) return { label: "High severity", color: "#b8894a" };
  if (n >= 9) return { label: "Critical severity", color: "#a8442f" };
  return null;
};

const ScaleOneToTen = ({selected, onChangeUpdateFunc, formValObj}) => {
  const band = selected ? severityBand(selected) : null;

  return (
    <div className="flex flex-col mt-3 gap-2 items-start font-plexsans">
      <div className="flex flex-wrap gap-1.5">
        {[...Array(10)].map((_, index) => {
          const value = index + 1;
          const isActive = selected !== null && selected !== undefined && value <= selected;

          return (
            <button
              type="button"
              key={value}
              onClick={(e) => onChangeUpdateFunc(e, {name: formValObj, valueTxt: value, type:"scale"})}
              className={`w-8 h-8 rounded-md border-[1.5px] text-[13px] font-semibold transition-colors
                ${isActive ? "border-tan bg-tan text-ivory" : "border-[rgba(20,33,61,.18)] bg-ivory text-[rgba(20,33,61,.55)] hover:border-[rgba(20,33,61,.35)]"}`}
            >
              {value}
            </button>
          );
        })}
      </div>
      {band && (
        <span className="text-xs font-semibold" style={{ color: band.color }}>
          {band.label}
        </span>
      )}
    </div>
  );
};

export default ScaleOneToTen;
